import React from 'react';
import { View } from 'react-native';
import type { Meta, StoryObj } from '@storybook/react';

import { ProgressStreak } from './ProgressStreak';

const days = (done: number, total = 7) =>
  Array.from({ length: total }, (_, index) => ({ done: index < done }));

const meta = {
  title: 'Challenges/ProgressStreak',
  component: ProgressStreak,
  args: {
    days: days(1),
    title: 'Challenge in progress',
    encouragement: 'You are on the right track, keep it up! 💪',
  },
  decorators: [
    Story => (
      <View style={{ width: 360 }}>
        <Story />
      </View>
    ),
  ],
} satisfies Meta<typeof ProgressStreak>;

export default meta;

type Story = StoryObj<typeof meta>;

export const DayOne: Story = {};

export const MidChallenge: Story = {
  args: { days: days(4) },
};

export const Bare: Story = {
  // chain only, without the card wrapper (congrats screens)
  args: { days: days(2), bare: true, title: undefined, encouragement: undefined },
};
